/* eslint-disable import/no-cycle */
import * as React from 'react';
import { TabStyles } from '../../styles/TabStyles';
import { makeTestId } from '../../utils/Declarative';
import { DialogType } from './DialogWidget';

const BodyStyles: React.CSSProperties = {
  boxSizing: 'border-box',
  flexGrow: 1,
  outline: 'none',
  overflow: 'auto',
  WebkitOverflowScrolling: 'touch',
};

export function getBodyPaddingStyle(type: DialogType, showFooter: boolean): Record<`padding${'Top' | 'Right' | 'Bottom' | 'Left'}`, number> {
  const style = {
    paddingTop: 0,
    paddingRight: TabStyles.Spacing.LargeSpace,
    paddingBottom: TabStyles.Spacing.LargeSpace,
    paddingLeft: TabStyles.Spacing.LargeSpace
  };

  switch (type) {
    case DialogType.NormalWithTitleBar:
      style.paddingTop = TabStyles.Spacing.LargeSpace;
      break;
    case DialogType.LightweightTitleBar:
      style.paddingLeft = TabStyles.Spacing.ExtraLargeSpace - TabStyles.Sizing.BorderWidth;
      style.paddingRight = style.paddingLeft;
      break;
    case DialogType.Uber:
      style.paddingTop = TabStyles.Spacing.MediumSpace;
      break;
    default:
      break;
  }

  if (showFooter) {
    style.paddingBottom = 0;
  }

  return style;
}

export interface DialogBodyProps {
  dialogBodyStyle?: React.CSSProperties;
  showFooter: boolean;
  testId: string;
  type: DialogType;
}

export const DialogBody: React.FC<DialogBodyProps> = props =>
  <div
    children={props.children}
    data-tb-test-id={makeTestId(props.testId, 'Body')}
    id={makeTestId(props.testId, 'Body-Id')}
    style={{
      ...BodyStyles,
      ...getBodyPaddingStyle(props.type, props.showFooter),
      ...props.dialogBodyStyle,
    }}
  />;
DialogBody.displayName = 'DialogBody';
